<template>
  <header ref="header" class="layout-header">
    <div ref="header_top" class="header_top ly-container">
      <div to="/index" class="group">
        <a>
          <img src="@/assets/logo.png" alt="logo img." class="logo_img" />
        </a>
      </div>
      <div class="group">
        <div class="search">
          <input
            v-model="searchText"
            type="text"
            :placeholder="
              EnglishIf ? 'Enter keywords to search' : '输入搜索关键词'
            "
            @keyup.enter="search"
          />
          <img src="@/assets/icon-search.png" alt="" @click="search" />
        </div>
        <div class="top-English">
          <div @click="setEnglishIf(1)" style="cursor: pointer">
            {{ EnglishIf ? "Chinese" : "中文" }}
          </div>
          <div class="line"></div>
          <div @click="setEnglishIf(2)" style="cursor: pointer">
            {{ "English" }}
          </div>
        </div>
      </div>
    </div>
    <div class="header_nav">
      <div class="ly-container">
        <ul class="main-nav nav">
          <!-- 一级菜单 -->
          <li
            v-for="(item, index) in navMenus"
            :key="index"
            :class="{ 'nav-item': true, active: item.active }"
          >
            <!-- <span v-if="item.children">{{ item.name }}</span> -->
            <router-link v-if="item.path" :to="item.path">
              <div v-if="EnglishIf">{{ item.nameEn == '' ?  item.name : item.nameEn }}</div>
              <div v-else>{{ item.name }}</div>
            </router-link>

            <a v-else :href="item.href">{{ subitem.name }}</a>

            <!-- 子菜单 -->
            <ul v-if="item.children" class="sub-nav">
              <li
                v-for="(subitem, subindex) in item.children"
                :key="subindex"
                :class="{ 'sub-nav-item': true, active: subitem.active }"
              >
                <router-link v-if="subitem.path" :to="subitem.path">{{
                  EnglishIf === false ? subitem.name : subitem.nameEn ? subitem.nameEn : subitem.name
                }}</router-link>
                <a v-else :href="subitem.href" target="_blank">{{
                  subitem.name
                }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    <div class="mobile-header">
      <div
        :class="['btn-wrapper', mobileNavVisible ? 'active' : '']"
        @click="mobileNavVisible = !mobileNavVisible"
      >
        <img src="@/assets/mobile.png" alt="" />
      </div>
      <div class="logo-wrapper">
        <a>
          <img src="@/assets/logo.png" class="logo_img" />
        </a>
        <!-- <router-link to="/index">
          <img src="@/assets/logo-text.png" class="logo_img2" />
        </router-link> -->
      </div>
      <div class="English">
        <div @click="setEnglishIf(1)" style="cursor: pointer">
          {{ EnglishIf ? "Chinese" : "中文" }}
        </div>
        <div class="line"></div>
        <div @click="setEnglishIf(2)" style="cursor: pointer">
          {{ "English" }}
        </div>
      </div>
      <ul class="mobile-main-nav">
        <!-- 一级菜单 -->
        <li
          v-for="(item, index) in navMenus"
          :key="index"
          :class="{ 'nav-item': true, active: item.active }"
          @click="setActive(item.path)"
        >
          <!-- <span v-if="item.children">{{ item.name }}</span> -->
          <router-link v-if="item.path" :to="item.path">
            <div v-if="EnglishIf">{{ item.nameEn ? item.nameEn : item.name}}</div>
            <div v-else>{{item.name }}</div>
          </router-link>
          <a v-else :href="item.href">{{ EnglishIf ?  item.nameEn : item.name }}</a>

          <!-- 子菜单 -->
          <ul v-if="item.children" class="sub-nav">
            <li
              v-for="(subitem, subindex) in item.children"
              :key="subindex"
              :class="{ 'sub-nav-item': true, active: subitem.active }"
            >
              <router-link v-if="subitem.path" :to="subitem.path"><div v-if="EnglishIf">{{ subitem.nameEn ? subitem.nameEn : subitem.name}}</div>
            <div v-else>{{subitem.name }}</div></router-link>
              <a v-else :href="subitem.href" target="_blank">{{
                subitem.name
              }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { cataloglist } from "@/api/index";
import { isMobile } from "@/utils/index";

export default {
  name: "LayoutHeader",
  data() {
    return {
      searchText: "",
      isHeaderVisible: true,
      lastScrollTop: 0,
      mobileNavVisible: false,
      EnglishIf: false,
      navMenus: [
        {
          name: "首页",
          path: "/index",
          active: false,
          nameEn: "Homepage",
        },
        {
          name: "关于我们",
          path: "/about",
          active: false,
          children: [
            {
              name: "基金会介绍",
              // nameEn: "Foundation Introduction",
              path: "/about/foundation",
              active: false,
            },
            {
              name: "理事会及监事会",
              // nameEn: "Board of Directors",
              path: "/about/council-supervisors",
              active: false,
            },
            {
              name: "基金会章程",
              // nameEn: "Foundation Charter",
              path: "/about/charter",
              active: false,
            },
            {
              name: "管理制度",
              // nameEn: "Management System",
              path: "/about/governance",
              active: false,
            },
            {
              name: "资质证书",
              nameEn: "Certificate",
              path: "/about/certificates",
              active: false,
            },
          ],
        },
        {
          name: "新闻中心",
          path: "/notice",
          active: false,
          children: [
            // { name: "党建专栏", path: "/notice/djzl", active: false },
            { name: "公益动态", path: "/notice/gydt", active: false },
            { name: "网站公告", path: "/notice/wzgg", active: false },
            // { name: "项目动态", path: "/project/list2", active: false },
            { name: "视频动态", path: "/notice/spdt", active: false },
            // { name: "故乡杂志", path: "/notice/gxzz", active: false },
          ],
        },
        {
          name: "党建专栏",
          path: "/notice/djzl",
          active: false,
        },
        {
          name: "项目中心",
          path: "/project",
          active: false,
          children: [
            {
              name: "大师对话",
              path: "/project/list?catalogAlisa=dsdh",
              active: false,
            },
            {
              name: "水乡社戏",
              path: "/project/list?catalogAlisa=sxsx",
              active: false,
            },
            // {
            //   name: "绍兴鲁迅纪念周",
            //   path: "/project/shaoxing-culture?catalogAlisa=lxwhz",
            //   active: false,
            // },
            {
              name: "上海鲁迅文化周",
              path: "/project/list?catalogAlisa=shlxwhz",
              active: false,
            },
            {
              name: "上海鲁迅文学周",
              path: "/project/list?catalogAlisa=shlxwxz",
              active: false,
            },
            {
              name: "绍兴文化事业发展",
              path: "/project/shaoxing-culture",
              active: false,
            },
            {
              name: "立人教育",
              path: "/project/liren-education",
              active: false,
            },
            {
              name: "灯火计划",
              path: "/project/list?catalogAlisa=dhjh",
              active: false,
            },
            {
              name: "鲁迅文化论坛",
              path: "/project/list?catalogAlisa=lxwhlt",
              active: false,
            },
            {
              name: "专项基金",
              path: "/project/list?catalogAlisa=zxjj",
              active: false,
            },
            {
              name: "照片展",
              path: "/project/list?catalogAlisa=zpz",
              active: false,
            },
            // {
            //   name: "鲁迅青少年文化展演",
            //   path: "/project/liren-education?catalogAlisa=lxqsnwhzy",
            //   active: false,
            // },
            // {
            //   name: "我为鲁迅爷爷过生日",
            //   path: "/project/list?catalogAlisa=wwlxyygsr",
            //   active: false,
            // },
            // {
            //   name: "鲁迅校际交流会",
            //   path: "/project/liren-education?catalogAlisa=lxxjjlh",
            //   active: false,
            // },
            // {
            //   name: "鲁迅文化跑",
            //   path: "/project/list?catalogAlisa=lxwhp",
            //   active: false,
            // },
            // {
            //   name: "鲁迅青少年文学大赛",
            //   path: "/project/liren-education?catalogAlisa=lxqsnwxj",
            //   active: false,
            // },
            // {
            //   name: "故乡杂志",
            //   path: "/project/shaoxing-culture?catalogAlisa=gxzz",
            //   active: false,
            // },
            // {
            //   name: "青少年素质成长中心",
            //   path: "/project/list?catalogAlisa=qsnszczzx",
            //   active: false,
            // },
          ],
        },
        {
          name: "信息公开",
          path: "/message/gzbg?catalogAlisa=ndbg",
          active: false,
          children: [
            {
              name: "年度报告",
              // nameEn: "Annual Report",
              path: "/message/gzbg?catalogAlisa=ndbg",
              active: false,
            },
            {
              name: "审计报告",
              path: "/message/gzbg?catalogAlisa=sjbg",
              active: false,
            },
            // {
            //   name: "管理制度",
            //   path: "/message/gzbg?catalogAlisa=glzd",
            //   active: false,
            // },
            {
              name: "项目报告",
              path: "/message/gzbg?catalogAlisa=xmbg",
              active: false,
            },
            {
              name: "社会评价",
              path: "/message/gzbg?catalogAlisa=shpj",
              active: false,
            },
            // { name: "资质证书", path: "/about/list?type=3", active: false, },
            // { name: "管理制度", path: "/message/glzd", active: false },
            // { name: "爱心榜", path: "/message/list", active: false },
          ],
        },
        {
          name: "支持我们",
          path: "/support",
          active: false,
          children: [
            {
              name: "捐赠信息",
              nameEn: "Donation Information",
              path: "/support/donation",
              active: false,
            },
            {
              name: "志愿者招募",
              // nameEn: "Volunteer Recruitment",
              path: "/support/volunteers",
              active: false,
            },
            {
              name: "联系我们",
              // nameEn: "Contact Us",
              path: "/support/contact",
              active: false,
            },
          ],
        },
      ],
    };
  },
  watch: {
    $route(to) {
      if (isMobile()) {
        this.mobileNavVisible = false;
      }
      this.setActive(to.fullPath);
    },
  },
  created() {
    cataloglist().then((res) => {
      const catalogTreeDataList = res.catalogTreeDataList || [];

      this.navMenus.forEach((menuItem) => {
        const matchedCatalog = catalogTreeDataList.find(
          (catalogItem) => catalogItem.name === menuItem.name,
        );
        if (!matchedCatalog) {
          return;
        }

        if (matchedCatalog.nameEn) {
          menuItem.nameEn = matchedCatalog.nameEn;
        }

        if (!menuItem.children?.length) {
          return;
        }

        menuItem.children.forEach((subItem) => {
          const matchedChildCatalog = this.findCatalogByMenuItem(
            subItem,
            matchedCatalog.childrenList || [],
          );
          if (matchedChildCatalog?.nameEn) {
            subItem.nameEn = matchedChildCatalog.nameEn;
          }
        });
      });
      if (localStorage.getItem("EnglishIf")) {
        this.EnglishIf =
          localStorage.getItem("EnglishIf") == "true" ? true : false;
        
      }
    });
  },

  mounted() {
    this.setActive(this.$route.fullPath);

    window.addEventListener("click", (e) => {
      if (this.mobileNavVisible && !e.target.closest(".mobile-header")) {
        this.mobileNavVisible = false;
      }
    });
    const that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "EnglishIf") {
        
        that.EnglishIf = JSON.parse(e.newValue);
      }
    });
  },
  beforeUnmount() {
    // window.removeEventListener('scroll',  this.debouncedHandleScroll);
  },
  methods: {
    getCatalogAliasFromPath(path) {
      if (!path || !path.includes("?")) {
        return "";
      }
      const queryString = path.split("?")[1];
      return new URLSearchParams(queryString).get("catalogAlisa") || "";
    },
    findCatalogByMenuItem(menuItem, catalogList) {
      const targetAlias = this.getCatalogAliasFromPath(menuItem.path);

      for (const catalogItem of catalogList) {
        if (targetAlias && catalogItem.alias === targetAlias) {
          return catalogItem;
        }

        if (!targetAlias && catalogItem.name === menuItem.name) {
          return catalogItem;
        }

        if (catalogItem.childrenList?.length) {
          const matchedChildCatalog = this.findCatalogByMenuItem(
            menuItem,
            catalogItem.childrenList,
          );
          if (matchedChildCatalog) {
            return matchedChildCatalog;
          }
        }
      }

      return null;
    },
    setEnglishIf(type) {
      if (type == 1) {
        localStorage.setItem("EnglishIf", false);
      } else {
        localStorage.setItem("EnglishIf", true);
      }
    },
    handleClickItem(item) {
      this.setActive(item.path);
      if (isMobile()) {
        item.active = true;
      }
    },
    setActive(path) {
      const [currentPath, queryString = ""] = path.split("?");
      const catalogAlias = new URLSearchParams(queryString).get("catalogAlisa");
      const activeTopPath = this.navMenus.reduce((matchedPath, item) => {
        const itemPath = item.path ? item.path.split("?")[0] : "";
        const isPartyBuildingDetail =
          currentPath === "/notice/detail" &&
          ["djzl", "djzl1"].includes(catalogAlias) &&
          item.path === "/notice/djzl";
        const isMatched =
          isPartyBuildingDetail ||
          (itemPath &&
            (currentPath === itemPath ||
              currentPath.startsWith(`${itemPath}/`)));
        return isMatched && itemPath.length > matchedPath.length
          ? itemPath
          : matchedPath;
      }, "");

      this.navMenus.forEach((item) => {
        const itemPath = item.path ? item.path.split("?")[0] : "";
        item.active = Boolean(activeTopPath) && itemPath === activeTopPath;
        if (item.children) {
          item.children.forEach((subitem) => {
            subitem.active =
              subitem.path === path ||
              (!subitem.path.includes("?") && subitem.path === currentPath);
          });
        }
      });
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    search() {
      this.$router.push({
        path: "/search",
        query: {
          keyword: this.searchText,
        },
      });
      this.searchText = "";
    },
    handleScroll() {
      const currentScrollTop = parseInt(window.scrollY || window.pageYOffset);
      // console.log(currentScrollTop, this.lastScrollTop);

      const isScrollingUp = currentScrollTop < this.lastScrollTop;

      if (isScrollingUp !== this.isHeaderVisible) {
        if (!this.$refs.header) return;

        if (isScrollingUp) {
          // 向上滚动
          this.$refs.header.style.transform = "translateY(0px)";
        } else {
          // 向下滚动
          this.$refs.header.style.transform =
            "translateY(calc(var(--header-top-height) * -1))";
        }
        this.isHeaderVisible = isScrollingUp;
      }
      this.lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // For Firefox
    },
  },
};
</script>

<style scoped lang="less">
.layout-header {
  --header-top-height: 100px;
  position: sticky;
  top: 0;
  background-color: white;
  background-image: url("@/assets/back.png");
  background-repeat: repeat;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  z-index: 10;
  // transition: transform 0.3s;
}
.header_top {
  height: var(--header-top-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  color: var(--primary-color);
  text-wrap: nowrap;
  word-wrap: none;

  .logo_img {
    width: 400px;
    margin-right: 15px;
  }
  .logo_img2 {
    width: 280px;
    transform: translateY(-8px);
  }

  .group {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .text1 {
    font-family: cursive, fangsong, monospace, serif;
    font-size: 40px;
    font-weight: 600;
    margin-left: 20px;
  }
  .text2,
  .text3 {
    font-size: 22px;
    margin: auto;
  }

  .search {
    border: 1px solid var(--primary-color);
    border-radius: 50px;
    display: flex;
    align-items: center;
    padding: 2px 15px 2px 10px;
    font-size: 19px;
    input {
      width: 200px;
      height: 30px;
      border: none;
      outline: none;
      border-radius: 5px;
      padding-left: 10px;
      background: transparent;
      color: var(--primary-color);
      &::placeholder {
        color: var(--primary-color);
      }
    }
    img {
      cursor: pointer;
    }
  }
}
.header_nav {
  background-color: var(--primary-color);
  font-size: 19px;
}
.main-nav {
  display: flex;
  color: white;
  height: 50px;
  align-items: center;
  .nav-item {
    height: 100%;
    line-height: 50px;
    flex: 1;
    text-align: center;
    transition: all 0.2s;
    position: relative;
    overflow: hidden;
    a {
      display: block;
      height: 100%;
    }
    &:hover {
      overflow: visible;
      color: white;
      background-color: rgba(173, 227, 255, 0.3);

      .sub-nav {
        top: 50px;
        opacity: 1;
      }
    }
    &.active {
      color: white;
      background-color: #b0d032;
      font-weight: 600;
    }
  }
  .sub-nav {
    width: 100%;
    position: absolute;
    top: 0;
    opacity: 0;
    z-index: -1;
    transition: all 0.2s;
    color: black;
    font-size: 0.9em;
    background-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    .sub-nav-item {
      padding: 10px 5px;
      line-height: 1;
      text-align: center;
      cursor: pointer;
      border-bottom: #e6e6e6 solid 1px;

      &:hover {
        color: #5b2400;
        background-color: rgba(173, 227, 255, 0.3);
      }
      &.active {
        color: #5b2400;
        background-color: rgba(173, 227, 255, 0.3);
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
}

// 移动端
.mobile-header {
  display: none;
  position: relative;
  z-index: 1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  height: 80px;
  .logo-wrapper {
    padding-left: 10px;
    a {
      display: block;
    }
    .logo_img {
      height: 45%;
      padding-top: 5px;
    }
    .logo_img2 {
      height: 45%;
    }
    .text {
      font-size: 22px;
      font-weight: 600;
      letter-spacing: 2px;
      color: var(--primary-color);
    }
  }
  .btn-wrapper {
    font-size: 20px;
    height: 80px;
    line-height: 80px;
    padding-left: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 1.2rem;
      height: 1.2rem;
    }
    &.active {
      color: var(--primary-color);
      & ~ .mobile-main-nav {
        display: block;
      }
    }
  }
}
.mobile-main-nav {
  box-sizing: border-box;
  display: none;
  min-height: 100%;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: -1;
  background-color: white;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  .nav-item {
    position: relative;
    padding: 5px;

    a {
      display: block;
      height: 100%;
    }
    &.active {
      font-weight: 600;
      .sub-nav {
        display: block;
      }
    }
  }
  .sub-nav {
    display: none;
    color: black;
    background-color: rgba(255, 255, 255);

    .sub-nav-item {
      cursor: pointer;
      padding: 5px;
      padding-left: 1em;
      &.active {
        color: white;
        background-color: #b0d03280;
      }
      &:last-child {
        border-bottom: none;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .header_top {
    .logo_img {
      width: 300px;
    }
    .text {
      flex: 0 0 auto;
      color: var(--primary-color);
      &.text1 {
        font-size: 26px;
        font-weight: 600;
      }
      &.text2,
      &.text3 {
        font-size: 22px;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .header_top {
    .group:nth-child(2) {
      display: none;
    }
    .group:nth-child(3) {
      margin-left: auto;
    }
    .search input {
      width: 140px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header_top,
  .header_nav {
    display: none;
  }
  .mobile-header {
    display: flex;
    justify-content: flex-start;
    .logo-wrapper {
      display: flex;
      align-items: center;
      > a {
        width: 13rem;
        flex: 1;
      }
      .logo_img {
        width: 100%;
        height: 100%;
      }
      .logo_img2 {
        width: 80%;
        height: 100%;
        margin-left: 10px;
      }
    }
  }
}
.top-English {
  display: flex;
  align-items: center;
  color: #ddd;
  color: #5b2400;
  font-size: 1vw;
  float: right;
  margin-left: 1vw;
  font-weight: 550;
  .line {
    height: 1.4rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    width: 2px;
    background: #5b2400;
  }
}
.English {
  display: flex;
  align-items: center;
  color: #ddd;
  color: #5b2400;
  font-size: 1.2rem;
  float: right;
  position: absolute;
  right: 2rem;
  height: 5rem;
  font-weight: 550;
  .line {
    height: 1.4rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    width: 2px;
    background: #5b2400;
  }
}
@media screen and (max-width: 768px) {
  .English {
    display: flex;
    align-items: center;
    color: #ddd;
    color: #5b2400;
    font-size: 1rem;
    float: right;
    position: absolute;
    right: 1rem;
    margin-top: 0.2rem;
    height: 5rem;
    font-weight: 550;
  }
}
</style>
